<!-- Spectacular Hero Section -->
<section class="hero-section" id="home">
  <div class="hero-background">
    <div class="gradient-orb orb-1"></div>
    <div class="gradient-orb orb-2"></div>
    <div class="gradient-orb orb-3"></div>
    <div class="floating-shapes">
      <div class="shape shape-1"></div>
      <div class="shape shape-2"></div>
      <div class="shape shape-3"></div>
      <div class="shape shape-4"></div>
    </div>
  </div>
  <div class="hero-container">
    <div class="hero-content">
      <div class="content-wrapper">
        <div class="hero-badge">
          <span class="badge-icon">🎓</span>
          <span class="badge-text">#1 Digital School Experience in Tunisia</span>
        </div>
        <h1 class="hero-title">
          Unlock Your
          <span class="title-highlight">Academic Potential</span>
          with Tenjah School
        </h1>
        <p class="hero-description">
          Join Tunisia's leading digital school where learning meets innovation.
          Access your courses, track your progress, connect with teachers, and
          achieve your academic goals in one seamless platform.
        </p>
        <div class="hero-actions">
          <a routerLink="/register" class="primary-cta">
            <span class="cta-icon">🎓</span>
            <span class="cta-text">Enroll Now</span>
            <div class="cta-shine"></div>
          </a>
          <button (click)="playVideo()" class="secondary-cta">
            <div class="play-circle">
              <span class="play-icon">▶</span>
            </div>
            <span class="cta-text">Watch Demo</span>
          </button>
        </div>
        <div class="hero-stats">
          <div class="stat-item" *ngFor="let stat of quickStats">
            <div class="stat-number">{{ stat.number }}</div>
            <div class="stat-label">{{ stat.label }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="hero-visual">
      <div class="dashboard-mockup">
        <div class="mockup-header">
          <div class="header-controls">
            <span class="control red"></span>
            <span class="control yellow"></span>
            <span class="control green"></span>
          </div>
          <div class="header-title">Tenjah Dashboard</div>
        </div>
        <div class="mockup-content">
          <div class="dashboard-sidebar">
            <div class="sidebar-item active">📊 Analytics</div>
            <div class="sidebar-item">👥 Students</div>
            <div class="sidebar-item">🎓 Teachers</div>
            <div class="sidebar-item">💰 Payments</div>
          </div>
          <div class="dashboard-main">
            <div class="chart-area">
              <div class="chart-bars">
                <div class="bar" style="height: 60%"></div>
                <div class="bar" style="height: 80%"></div>
                <div class="bar" style="height: 45%"></div>
                <div class="bar" style="height: 90%"></div>
                <div class="bar" style="height: 70%"></div>
              </div>
            </div>
            <div class="stats-cards">
              <div class="mini-card">
                <div class="card-icon">👨‍🎓</div>
                <div class="card-number">2,847</div>
              </div>
              <div class="mini-card">
                <div class="card-icon">📈</div>
                <div class="card-number">94%</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>